import { getData, htmlTag, fittingTypes } from '@wix/image-kit'

export const wixMediaUrlFormatterOriginalArgsParamName = 'formatterValues'
const addOriginalFormatterArgsToUrl = (imageUrl: string, args: Array<string>) => {
	const paramsPrefix = imageUrl.includes('?') ? '&' : '?'
	return `${imageUrl}${paramsPrefix}${wixMediaUrlFormatterOriginalArgsParamName}=${args.join(',')}`
}

type Dimensions = {
	width: string
	height: string
}
export const resolveWixMediaUrl = (
	staticMediaUrl: string,
	uri: string,
	dimensions: Dimensions,
	shouldUseWebp = true
) => {
	const { width: originalWidth, height: originalHeight } = dimensions
	const width = Number.parseInt(originalWidth, 10)
	const height = Number.parseInt(originalHeight, 10)

	const result = getData(
		fittingTypes.SCALE_TO_FILL,
		{
			id: uri,
			width,
			height,
		},
		{
			width,
			height,
			htmlTag: htmlTag.BG,
			alignment: 'center',
		}
	)

	const resultUri = result.uri || uri
	let imageUrl = staticMediaUrl + '/' + resultUri

	if (shouldUseWebp && resultUri.match(/((.jpg)|(.jpeg)|(.png))$/)) {
		imageUrl = imageUrl.concat('.webp')
	}

	imageUrl = addOriginalFormatterArgsToUrl(imageUrl, [uri, originalWidth, originalHeight])

	return `url("${imageUrl}")`
}
